const TOKEN_KEY = 'dhses_token'
const USER_KEY = 'dhses_user'
const ENROLL_TOKEN_KEY = 'dhses_enroll_token'
const ENROLL_USER_KEY = 'dhses_enroll_user'

export function getToken() {
    return localStorage.getItem(TOKEN_KEY) || ''
}

export function setToken(token) {
    localStorage.setItem(TOKEN_KEY, token)
}

export function getUser() {
    const raw = localStorage.getItem(USER_KEY)
    if (!raw) return null
    try {
        return JSON.parse(raw)
    } catch (error) {
        return null
    }
}

export function setUser(user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user))
}

export function isLoggedIn() {
    return !!getToken()
}

export function isAdmin() {
    const user = getUser()
    return !!user && !!user.is_admin
}

export function clearAuth() {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USER_KEY)
}

export function getEnrollToken() {
    return localStorage.getItem(ENROLL_TOKEN_KEY) || ''
}

export function setEnrollToken(token) {
    localStorage.setItem(ENROLL_TOKEN_KEY, token)
}

export function getEnrollUser() {
    const raw = localStorage.getItem(ENROLL_USER_KEY)
    if (!raw) return null
    try {
        return JSON.parse(raw)
    } catch (error) {
        return null
    }
}

export function setEnrollUser(user) {
    localStorage.setItem(ENROLL_USER_KEY, JSON.stringify(user))
}

export function clearEnrollAuth() {
    localStorage.removeItem(ENROLL_TOKEN_KEY)
    localStorage.removeItem(ENROLL_USER_KEY)
}
